import styled from 'styled-components';
import { Button } from '@upgrade/react-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledButton = styled(Button)`
  width: 100%;
  &:disabled {
    opacity: 1;
  }

  span {
    /* Consistent font size between mobile and desktop */
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
  }
`;
